
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ContactCTA from '@/components/ContactCTA';
import SEOMetadata from '@/components/SEOMetadata';
import BrokerageHero from '@/components/brokerage/BrokerageHero';
import BrokerageComparison from '@/components/brokerage/BrokerageComparison';
import BrokerageFeatures from '@/components/brokerage/BrokerageFeatures';
import BrokerageUseCases from '@/components/brokerage/BrokerageUseCases';
import BrokerageCostSavings from '@/components/brokerage/BrokerageCostSavings';
import BrokeragePhilosophy from '@/components/brokerage/BrokeragePhilosophy';
import BrokerageFinalCTA from '@/components/brokerage/BrokerageFinalCTA';

const Brokerage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "IP Brokerage Services",
    "provider": {
      "@type": "Organization",
      "name": "NEXX TELECOM"
    },
    "description": "Professional IP address brokerage and consulting services. Buy, sell, and manage IP address blocks with expert guidance.",
    "serviceType": "IP Address Brokerage",
    "areaServed": "Global"
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOMetadata
        title="IP Brokerage Services | Buy & Sell IP Addresses | NEXX"
        description="Professional IP address brokerage services. Expert consultation for buying, selling, and managing IP address blocks. Maximize your IP asset value."
        keywords="IP brokerage, IP address broker, buy IP addresses, sell IP addresses, IP consulting, IPv4 brokerage, IP asset management"
        canonical="https://nexx.net/brokerage"
        structuredData={structuredData}
      />
      <Header />
      <BrokerageHero />
      <BrokerageComparison />
      <BrokerageFeatures />
      <BrokerageUseCases />
      <BrokerageCostSavings />
      <BrokeragePhilosophy />
      <BrokerageFinalCTA />
      <ContactCTA />
      <Footer />
    </div>
  );
};

export default Brokerage;
